const QUESTION_TYPES = [
  'text_field',
  'text_area',
  'attachment',
  'multiple_choice',
  'multi_select'
];

export default QUESTION_TYPES;
